"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../schema");
const value = schema_1.Schema.number()
    .integer()
    .min(0)
    .max(20)
    .interpretation({ vocab: "htx", code: "number_of_thoracotomies" })
    .tag({ vocab: "snomed", code: "177765008" });
const summary = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "htx", code: "summary_of_thoracotomies" })
    .tag({ vocab: "snomed", code: "177765008" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ value, summary });
